import anyPass from "ramda/es/anyPass";
import assocPath from "ramda/es/assocPath";
import head from "ramda/es/head";
import identity from "ramda/es/identity";
import isEmpty from "ramda/es/isEmpty";
import o from "ramda/es/o";
import test from "ramda/es/test";
import { GENERIC_REACT_WARNINGS, instrumentTypes } from '../../constants';
const isDiffNextPrev = o(test(/^(diff|next|prev)$/), head);
const isStateLog = o(test(/^(%c prev state|%c action|%c next state)$/), head);
const isReactWarning = (args)=>{
    const firstArg = args[0];
    for (const warning of GENERIC_REACT_WARNINGS){
        if (firstArg.includes(warning)) {
            return true;
        }
    }
    return false;
};
const shouldRejectConsoleMessage = (event)=>anyPass([
        isEmpty,
        isDiffNextPrev,
        isStateLog,
        isReactWarning
    ])(event?.description?.args);
export const defaultConsoleTransformer = (event)=>{
    if (shouldRejectConsoleMessage(event)) {
        return null;
    } else {
        return event;
    }
};
export const defaultReduxTransformer = (event)=>{
    if (event?.description?.payload?.data?.body) {
        return {
            ...event,
            description: assocPath([
                'payload',
                'data',
                'body'
            ], '<truncated>', event.description)
        };
    } else {
        return event;
    }
};
const instrumentTransformers = {
    [instrumentTypes.DOM]: identity,
    [instrumentTypes.FORM]: identity,
    [instrumentTypes.REDUX]: defaultReduxTransformer,
    [instrumentTypes.CONSOLE]: defaultConsoleTransformer,
    [instrumentTypes.XHR]: identity,
    [instrumentTypes.FETCH]: identity,
    [instrumentTypes.APM_TRANSACTION]: identity
};
export const getInstrumentTransformer = (instrumentType, breadcrumbTransformers = {})=>{
    const customTransformer = breadcrumbTransformers[instrumentType];
    const defaultTransformer = instrumentTransformers[instrumentType];
    return (event)=>{
        const defaultEventTransform = defaultTransformer(event);
        if (defaultEventTransform && customTransformer) {
            return customTransformer(defaultEventTransform);
        } else {
            return defaultEventTransform;
        }
    };
};
